// src/utils/utmTracking.js

export function initUTMTracking() {
  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function setCookie(name, value, days = 30) {
    if (!value) return;
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  }

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? decodeURIComponent(match[2]) : "";
  }

  /* ========= Capture UTMs from URL ========= */
  const utms = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
  ];

  utms.forEach((utm) => {
    const value = getParam(utm);
    if (value) setCookie(utm, value);
  });

  /* ========= Detect Traffic Source / Medium ========= */
  if (!getCookie("traffic_source")) {
    let source = "(direct)";
    let medium = "(none)";

    const utmSource = getCookie("utm_source");
    const utmMedium = getCookie("utm_medium");

    if (utmSource && utmMedium) {
      source = utmSource;
      medium = utmMedium;
    } else if (document.referrer) {
      try {
        const ref = new URL(document.referrer);
        const hostname = ref.hostname.replace("www.", "");

        if (hostname.includes("google")) {
          source = "google";
          medium = "organic";
        } else if (hostname.includes("bing")) {
          source = "bing";
          medium = "organic";
        } else if (hostname.includes("linkedin")) {
          source = "linkedin";
          medium = "referral";
        } else if (hostname !== window.location.hostname.replace("www.", "")) {
          source = hostname;
          medium = "referral";
        }
      } catch (e) {
        console.error("Error parsing referrer:", e);
      }
    }

    setCookie("traffic_source", source);
    setCookie("traffic_medium", medium);
  }

  /* ========= Return tracking data ========= */
  return {
    utm_source: getCookie("utm_source") || "",
    utm_medium: getCookie("utm_medium") || "",
    utm_campaign: getCookie("utm_campaign") || "",
    utm_content: getCookie("utm_content") || "",
    utm_term: getCookie("utm_term") || "",
    traffic_source: getCookie("traffic_source") || "(direct)",
    traffic_medium: getCookie("traffic_medium") || "(none)",
    source_medium: `${getCookie("traffic_source") || "(direct)"} / ${getCookie("traffic_medium") || "(none)"}`,
  };
}

export function getUTMData() {
  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? decodeURIComponent(match[2]) : "";
  }

  return {
    utm_source: getCookie("utm_source") || "",
    utm_medium: getCookie("utm_medium") || "",
    utm_campaign: getCookie("utm_campaign") || "",
    utm_content: getCookie("utm_content") || "",
    utm_term: getCookie("utm_term") || "",
    traffic_source: getCookie("traffic_source") || "(direct)",
    traffic_medium: getCookie("traffic_medium") || "(none)",
    source_medium: `${getCookie("traffic_source") || "(direct)"} / ${getCookie("traffic_medium") || "(none)"}`,
  };
}
